module.exports = __webpack_public_path__ + "img/product_14.817d5bc.jpg";